import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { inject } from '@angular/core';

export const AdminGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const router = inject(Router);
    const userRole = localStorage.getItem('user-role');
    const userId = localStorage.getItem('user-id');

    // Obtener la ruta completa
    const fullPath = route.pathFromRoot
        .map(r => r.url.map(segment => segment.path).join('/'))
        .join('/');
    
    // Solo aplicar el guard si la ruta empieza con 'admin/'
    const isAdminRoute = fullPath.includes('admin/');
    
    // Si NO es una ruta admin, permitir acceso (no es nuestro problema)
    if (!isAdminRoute) {
        return true;
    }

    // Si es contabilidad, permitir solo invoices y calculator
    if (userRole === 'contabilidad') {
        const allowed = ['admin/invoices', 'admin/calculator'];
        if (allowed.some(path => fullPath.includes(path))) {
            return true;
        }
        router.navigateByUrl('admin/invoices');
        return false;
    }

    // Si es ruta admin y el usuario NO es admin, redirigir
    if (userRole !== 'admin') {
        // Extraer la parte después de 'admin/'
        const adminPathMatch = fullPath.match(/admin\/(.+)/);
        
        if (adminPathMatch) {
            const pathAfterAdmin = adminPathMatch[1];
            
            // Mapeo de rutas admin a rutas de cliente
            const routeMap: { [key: string]: string } = {
                'calculator': 'calculator',
                'consolidations': 'consolidations',
                'dashboard': 'dashboard',
                'invoices': 'invoices',
                'packages': 'packages',
                'plans': 'plans',
                'prealert': 'prealert',
                'prealerts': 'prealerts'
            };

            // Buscar si existe una ruta homóloga
            const clientRoute = Object.keys(routeMap).find(key => 
                pathAfterAdmin.startsWith(key)
            );

            if (clientRoute && routeMap[clientRoute]) {
                // Redirigir a la ruta homóloga del cliente
                const redirectPath = pathAfterAdmin.replace(clientRoute, routeMap[clientRoute]);
                router.navigate([redirectPath]);
                return false;
            }
        }

        // Si no existe ruta homóloga, redirigir al perfil
        router.navigate([`profile/${userId}`]);
        return false;
    }

    // Si es admin y es ruta admin, permitir el acceso
    return true;
};
